import React, {Component, Fragment} from "react";
import ToastHelper from "../../utils/ToastHelper";
import ChatUserService from "../../services/chat/ChatUserService";
import {Channel as SBConversation, SendBirdProvider as SBProvider} from "sendbird-uikit";
import "sendbird-uikit/dist/index.css";
import "../../scss/sendbird.css"
import SFXLoadingComponent from "../SFXLoadingComponent";

const SENDBIRD_APP_ID = process.env.REACT_APP_SENDBIRD_APP_ID;

export default class ViewConversationComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            conversation: this.props.conversation,
            userId: this.props.userId,
            isLoading: true
        }
    }

    componentDidMount() {
        ChatUserService.retrieve(this.state.userId).then(
            response => {
                if (response.id) {
                    this.setState({
                        isLoading: false,
                        user: response
                    })
                } else {
                    if (this.props.onFailedToLoadUser) {
                        this.props.onFailedToLoadUser(response)
                    } else {
                        ToastHelper.formatError(response)
                    }
                }
            }
        );
    }

    render() {
        if (this.state.isLoading) {
            return <Fragment>
                    <SFXLoadingComponent style={{position: "", margin: "0 !important", width: "auto"}}/>
            </Fragment>
        }

        return <Fragment>
            <div>
                <SBProvider
                    appId={SENDBIRD_APP_ID}
                    userId={this.state.user.sendbirdUserId}
                    nickname={this.state.user.nickname}
                >
                    <SBConversation
                        channelUrl={this.state.conversation.sendbirdUrl}
                        useMessageGrouping={false}
                        useReaction={false}
                    />
                </SBProvider>
            </div>
        </Fragment>
    }
}